import ScrollWrapper from './ScrollWrapper';
export default ScrollWrapper;